import { render, staticRenderFns } from "./TrademarkSearchStatusForm.vue?vue&type=template&id=31faa6d4&"
import script from "./TrademarkSearchStatusForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchStatusForm.vue?vue&type=style&index=0&id=31faa6d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports